<div class="wrap margin-large-top-res">
    <div uk-grid class="uk-grid-small remove-grid-ml-pl">
        <div class="uk-width-1-2@s uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block">
                <button class="uk-button round-button uk-display-inline-block@m"
                    [class.round-button-toggle]="status === 0" (click)="changeStatus(0)">
                    Tout
                </button>
            </div>
            <div class="uk-form-controls uk-display-inline-block">
                <button class="uk-button round-button uk-display-inline-block@m"
                    [class.round-button-toggle]="status === 1" (click)="changeStatus(1)">
                    À venir
                </button>
            </div>
            <div class="uk-form-controls uk-display-inline-block">
                <button class="uk-button round-button uk-display-inline-block@m"
                    [class.round-button-toggle]="status === 2" (click)="changeStatus(2)">
                    En cours
                </button>
            </div>
            <div class="uk-form-controls uk-display-inline-block">
                <button class="uk-button round-button uk-display-inline-block@m"
                    [class.round-button-toggle]="status === 3" (click)="changeStatus(3)">
                    Clôturée
                </button>
            </div>
        </div>

        <div class="uk-width-1-2 uk-width-1-4@s uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block">
                <app-datepicker [(date)]="dateStart" (dateChange)="onDateChange(true, $event)"></app-datepicker>
                <app-datepicker [(date)]="dateEnd" (dateChange)="onDateChange(false, $event)"></app-datepicker>
            </div>
        </div>

        <div class="uk-width-1-4@m uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1">
                <input class="search-bar" type="search" [(ngModel)]="search" placeholder="Rechercher"
                    (ngModelChange)="onSearchChange($event)" style="width: calc(100% - 20px);">
                <span class="uk-form-icon uk-form-icon-flip" style="right: 10px;">
                    <img src="../../../assets/icons/Search.svg" width="24px" height="24px" alt="user" />
                </span>
            </div>
        </div>

        <div class="uk-width-1-1 uk-margin-top">
            <!-- <div *ngIf="session.role.ability === 'super-admin'" class="uk-display-inline-block research-form-controls">
                <label class="uk-form-label uk-display-inline-block vop-blue" for="form-stacked-text">
                    Adhérent
                </label>
                <div class="uk-form-controls uk-display-inline-block uk-position-relative">
                    <span *ngIf="societyLoading === true" class="uk-form-icon uk-form-icon-flip">
                        <div uk-spinner></div>
                    </span>
                    <input class="search-bar" type="text" [(ngModel)]="societySearch"
                        (ngModelChange)="updateSocietyOptionList($event)"
                        (focus)="toggleSuggestions(true)" (focusout)="toggleSuggestions(false)"
                        placeholder="Rechercher" style="padding-right: inherit !important; width: 200px;"
                    >
                    <div [class.display-none]="societyDisplay === false" class="suggestions">
                        <div [class.display-none]="societyOptions.length === 0" class="arrow"></div>
                        <div [class.display-none]="societyNoResult === false">
                            Pas de résultats
                        </div>
                        <div [class.display-none]="societyNoResult === true" *ngFor="let option of societyOptions"
                            (click)="setSocietySearch(option)"
                        >
                            {{ option.Code }}
                        </div>
                    </div>
                </div>
            </div> -->
            <button class="button bold uk-display-inline-block uk-float-right uk-margin-small-left"
                type="button" (click)="openNewReservationModal()">
                <span class="vertical-align-middle">Nouvelle réservation</span>
                <img src="../../../../assets/icons/Add.svg" width="32px" height="32px" alt="add"
                    class="uk-margin-left" onerror="this.style.display='none'" />
            </button>
            <button class="button bold uk-display-inline-block uk-float-right" (click)="exportDataAsXLSX()"
                type="button">
                <span *ngIf="excelLoading === false">
                    <span class="vertical-align-middle">Export</span>
                    <img src="../../../../assets/icons/Export.svg" width="32px" height="32px" alt="user"
                        class="uk-margin-left" />
                </span>
                <span *ngIf="excelLoading === true">
                    <div uk-spinner class="loading-small-button"></div>
                </span>
            </button>
        </div>
    </div>

    <div *ngIf="noResult === true" class="bold uk-margin-medium-top">
        Vous n'avez pas de réservations pour cette période.
    </div>

    <div *ngIf="loadingStatus === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loadingStatus === false && noResult === false" class="uk-margin-medium-top"
         [class.super-admin-list]="session.role.ability === 'super-admin'">

        <div *ngIf="loadingStatus === false && status === 0" uk-grid class="remove-grid-ml-pl uk-margin-remove-top">
            <div uk-grid *ngFor="let reservation of reservations; let i = index"
                class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer">
                <div class="uk-width-1-7@s uk-width-1-3 item-column bold rl-col-date"
                    [routerLink]="['/reservation/informations', reservation.Id]">
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}" noDay="true"
                            shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular"
                            hours="{{ reservation.ISODateStart }}"></span>
                    </div>
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}" noDay="true"
                            shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular"
                            hours="{{ reservation.ISODateEnd }}"></span>
                    </div>
                    <div class="separator"></div>
                </div>
                <div class="uk-width-1-7@s uk-width-1-3 item-column light uk-text-uppercase uk-text-center rl-col-vehicle" [routerLink]="['/reservation/informations', reservation.Id]">
                    {{ reservation.Vehicle }}
                    <div class="rl-brand-model">{{ reservation.Brand }} {{ reservation.Model }}</div>
                </div>
                <div class="uk-width-1-5@s uk-width-1-3 item-column bold uk-text-uppercase rl-col-user"
                    [routerLink]="['/reservation/informations', reservation.Id]">
                    {{ reservation.User }}
                </div>
                <div *ngIf="session.role.ability === 'super-admin'"
                    [routerLink]="['/reservation/informations', reservation.Id]"
                    class="uk-visible@s uk-width-1-6 item-column light uk-text-uppercase rl-col-society">
                    {{ reservation.CodeSociety }}
                </div>
                <div class="uk-visible@m uk-width-expand item-column rl-col-comment"
                    [routerLink]="['/reservation/informations', reservation.Id]"
                    (mouseenter)="initCommentTooltip($event, reservation)">
                    <div *ngIf="testMode" class="rl-comment-debug">({{ reservation.Id }}) statut {{ reservation.Status }}, {{ getStatus(reservation.Status) }}</div>
                    <span *ngIf="reservation.Comment" class="rl-comment-text">{{ reservation.Comment }}</span>
                </div>

                <div class="uk-visible@s uk-width-1-12 item-column rl-col-staff" *ngIf="reservation.demo === true"
                    [routerLink]="['/reservation/informations', reservation.Id]">
                    <span class="uk-badge" *ngIf="reservation.demo === true">Staff</span>
                    <!-- uk-display-inline-block -->
                </div>

                <div class="uk-visible@m uk-width-1-12 item-column">
                    <img *ngIf="reservation.Status == -1" class="uk-position-absolute"
                        uk-tooltip="Echec de pré-auto stripe" src="../../../assets/icons/status/echecPreAuto.svg"
                        width="35px" height="35px" alt="Echec de pré-auto stripe" />

                    <img *ngIf="reservation.Status >= 0 && reservation.Status <= 2" class="uk-position-absolute"
                        uk-tooltip="Confirmée" src="../../../assets/icons/status/new.svg" width="35px" height="35px"
                        alt="Confirmée" />

                    <img *ngIf="reservation.Status >= 3 && reservation.Status <= 4" class="uk-position-absolute"
                        uk-tooltip="État des lieux d'entrée en cours"
                        src="../../../assets/icons/status/inventory-enter.svg" width="35px" height="35px"
                        alt="En cours" />

                    <img *ngIf="reservation.Status >= 5 && reservation.Status <= 8" class="uk-position-absolute"
                        uk-tooltip="En cours" src="../../../assets/icons/status/En_cours.svg" width="35px" height="35px"
                        alt="En cours" />

                    <img *ngIf="reservation.Status >= 9 && reservation.Status <= 10" class="uk-position-absolute"
                        uk-tooltip="État des lieux de sortie en cours"
                        src="../../../assets/icons/status/inventory-final.svg" width="35px" height="35px"
                        alt="En cours" />

                    <img *ngIf="reservation.Status == 11" class="uk-position-absolute" uk-tooltip="Clôturée"
                        src="../../../assets/icons/status/Terminee.svg" width="35px" height="35px" alt="Terminée" />

                    <img *ngIf="reservation.Status == 12" class="uk-position-absolute"
                        uk-tooltip="En attente de Facturation"
                        src="../../../assets/icons/status/Attente-facturation.svg" width="35px" height="35px"
                        alt="adherent" />

                    <img *ngIf="reservation.Status == 13" class="uk-position-absolute" uk-tooltip="Facturé"
                        src="../../../assets/icons/status/Terminee-facture.svg" width="35px" height="35px"
                        alt="adherent" />

                    <img *ngIf="reservation.Status == 14" class="uk-position-absolute" uk-tooltip="Facturée"
                        src="../../../assets/icons/status/payer.svg" width="35px" height="35px" alt="adherent" />

                    <img *ngIf="reservation.Status === 20" class="uk-position-absolute" uk-tooltip="Annulée"
                        src="../../../assets/icons/status/Annule.svg" width="35px" height="35px" alt="adherent" />

                    <img *ngIf="reservation.Status == 21" uk-tooltip="Reservation non cloturé"
                        src="../../../assets/icons/status/Probleme.svg" width="35px" height="35px" alt="Warning"
                        [routerLink]="['/carsharing']" [queryParams]="{vehicule: reservation.Vehicle}" />
                </div>

                <div class="uk-visible@s uk-width-1-12 item-column rl-col-code"
                    [routerLink]="['/reservation/informations', reservation.Id]"
                    [class.color-green]="reservation.Status == 14" [class.color-orange]="reservation.Status == 12">
                    #{{ reservation.Code }}
                </div>
            </div>
        </div>

        <div *ngIf="reservations.length == 0 && status == 0" class="uk-text-center uk-margin-large-top">
            <div class="uk-text-center uk-margin-large-top">
                <img src="../../../../assets/icons/empty.svg" width="80px" height="80px" alt="empty" />
            </div>
            <div class="uk-text-center uk-margin-large-top">
                <span class="uk-text-bold">Aucune réservation</span>
            </div>
        </div>

        <div *ngIf="comeUp.length > 0" class="title bold uk-margin uk-margin-large-top">Réservations à venir</div>

        <div uk-grid class="remove-grid-ml-pl uk-margin-remove-top">
            <div uk-grid *ngFor="let reservation of comeUp; let i = index"
                class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer"
                [routerLink]="['/reservation/informations', reservation.Id]">
                <div class="uk-width-1-7@s uk-width-1-3 item-column bold rl-col-date">
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}" noDay="true"
                            shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular"
                            hours="{{ reservation.ISODateStart }}"></span>
                    </div>
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}" noDay="true"
                            shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular"
                            hours="{{ reservation.ISODateEnd }}"></span>
                    </div>
                    <div class="separator"></div>
                </div>
                <div class="uk-width-1-7@s uk-width-1-3 item-column light uk-text-uppercase uk-text-center rl-col-vehicle">
                    {{ reservation.Vehicle }}
                    <div class="rl-brand-model">{{ reservation.Brand }} {{ reservation.Model }}</div>
                </div>
                <div class="uk-width-1-5@s uk-width-1-3 item-column bold uk-text-uppercase rl-col-user">
                    {{ reservation.User }}
                </div>
                <div *ngIf="session.role.ability === 'super-admin'"
                    class="uk-visible@s uk-width-1-6 item-column light uk-text-uppercase rl-col-society">
                    {{ reservation.CodeSociety }}
                </div>
                <div class="uk-visible@m uk-width-expand item-column rl-col-comment"
                    (mouseenter)="initCommentTooltip($event, reservation)">
                    <div *ngIf="testMode" class="rl-comment-debug">({{ reservation.Id }}) statut {{ reservation.Status }}, {{ getStatus(reservation.Status) }}</div>
                    <span *ngIf="reservation.Comment" class="rl-comment-text">{{ reservation.Comment }}</span>
                </div>

                <div class="uk-visible@s uk-width-1-12 item-column rl-col-staff" *ngIf="reservation.demo === true">
                    <span class="uk-badge" *ngIf="reservation.demo === true">Staff</span>
                    <!-- uk-display-inline-block -->
                </div>
                <div class="uk-visible@s uk-width-1-12 item-column rl-col-code"
                    [class.color-green]="reservation.Status == 14" [class.color-orange]="reservation.Status == 12">
                    #{{ reservation.Code }}
                </div>
            </div>
        </div>

        <div *ngIf="comeUp.length == 0 && status == 1" class="uk-text-center uk-margin-large-top">
            <div class="uk-text-center uk-margin-large-top">
                <img src="../../../../assets/icons/empty.svg" width="80px" height="80px" alt="empty" />
            </div>
            <div class="uk-text-center uk-margin-large-top">
                <span class="uk-text-bold">Aucune réservation</span>
            </div>
        </div>

        <div *ngIf="inProgress.length > 0" class="title bold uk-margin uk-margin-large-top">Réservations démarrées</div>

        <div uk-grid class="remove-grid-ml-pl uk-margin-remove-top">
            <div uk-grid *ngFor="let reservation of inProgress; let i = index"
                class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer"
                [routerLink]="['/reservation/informations', reservation.Id]">
                <div class="uk-width-1-7@s uk-width-1-3 item-column bold rl-col-date">
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}" noDay="true"
                            shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular"
                            hours="{{ reservation.ISODateStart }}"></span>
                    </div>
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}" noDay="true"
                            shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular"
                            hours="{{ reservation.ISODateEnd }}"></span>
                    </div>
                    <div class="separator"></div>
                </div>
                <div class="uk-width-1-7@s uk-width-1-3 item-column light uk-text-uppercase uk-text-center rl-col-vehicle">
                    {{ reservation.Vehicle }}
                    <div class="rl-brand-model">{{ reservation.Brand }} {{ reservation.Model }}</div>
                </div>
                <div class="uk-width-1-5@s uk-width-1-3 item-column bold uk-text-uppercase rl-col-user">
                    {{ reservation.User }}
                </div>
                <div *ngIf="session.role.ability === 'super-admin'"
                    class="uk-visible@s uk-width-1-6 item-column light uk-text-uppercase rl-col-society">
                    {{ reservation.CodeSociety }}
                </div>
                <div class="uk-visible@s uk-width-expand item-column rl-col-comment"
                    (mouseenter)="initCommentTooltip($event, reservation)">
                    <div *ngIf="testMode" class="rl-comment-debug">({{ reservation.Id }}) statut {{ reservation.Status }}, {{ getStatus(reservation.Status) }}</div>
                    <span *ngIf="reservation.Comment" class="rl-comment-text">{{ reservation.Comment }}</span>
                </div>
                <div class="uk-visible@s uk-width-1-12 item-column rl-col-staff" *ngIf="reservation.demo === true">
                    <span class="uk-badge" *ngIf="reservation.demo === true">Staff</span>
                    <!-- uk-display-inline-block -->
                </div>
                <div class="uk-visible@s uk-width-1-12 item-column rl-col-code"
                    [class.color-green]="reservation.Status == 14" [class.color-orange]="reservation.Status == 12">
                    #{{ reservation.Code }}
                </div>
            </div>
        </div>

        <div *ngIf="inProgress.length == 0 && status == 2" class="uk-text-center uk-margin-large-top">
            <div class="uk-text-center uk-margin-large-top">
                <img src="../../../../assets/icons/empty.svg" width="80px" height="80px" alt="empty" />
            </div>
            <div class="uk-text-center uk-margin-large-top">
                <span class="uk-text-bold">Aucune réservation</span>
            </div>
        </div>

        <div *ngIf="finished.length > 0" class="title bold uk-margin uk-margin-large-top">Réservations clôturées</div>

        <div uk-grid class="remove-grid-ml-pl uk-margin-remove-top">
            <a uk-grid *ngFor="let reservation of finished; let i = index" href="#"
                class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer"
                [routerLink]="['/reservation/informations', reservation.Id]">
                <div class="uk-width-1-7@s uk-width-1-3  item-column bold uk-position-relative rl-col-date">
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}" noDay="true"
                            shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular"
                            hours="{{ reservation.ISODateStart }}"></span>
                    </div>
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}" noDay="true"
                            shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular"
                            hours="{{ reservation.ISODateEnd }}"></span>
                    </div>
                    <div class="separator"></div>
                </div>
                <div class="uk-width-1-7@s uk-width-1-3  item-column light uk-text-uppercase uk-text-center rl-col-vehicle">
                    {{ reservation.Vehicle }}
                    <div class="rl-brand-model">{{ reservation.Brand }} {{ reservation.Model }}</div>
                </div>
                <div class="uk-width-1-5@s uk-width-1-3  item-column bold uk-text-uppercase rl-col-user">
                    {{ reservation.User }}
                </div>
                <div *ngIf="session.role.ability === 'super-admin'"
                    class="uk-visible@s uk-width-1-5 item-column light uk-text-uppercase rl-col-society">
                    {{ reservation.CodeSociety }}
                </div>
                <div class="uk-visible@s uk-width-expand item-column rl-col-comment"
                    (mouseenter)="initCommentTooltip($event, reservation)">
                    <div *ngIf="testMode" class="rl-comment-debug">({{ reservation.Id }}) statut {{ reservation.Status }}, {{ getStatus(reservation.Status) }}</div>
                    <span *ngIf="reservation.Comment" class="rl-comment-text">{{ reservation.Comment }}</span>
                </div>
                <div class="uk-visible@s uk-width-1-12 item-column bold rl-col-amount"
                    *ngIf="reservation.totalAmount > 0 && reservation.demo === false">
                    {{ reservation.totalAmount.toFixed(2) }}€
                </div>
                <div class="uk-visible@m uk-width-1-12 item-column rl-col-staff" *ngIf="reservation.demo === true">
                    <span class="uk-badge" *ngIf="reservation.demo === true">Staff</span>
                    <!-- uk-display-inline-block -->
                </div>

                <div class="uk-visible@s uk-width-1-12 item-column rl-col-code" [class.color-green]="reservation.Status == 14"
                    [class.color-orange]="reservation.Status == 12">
                    #{{ reservation.Code }}
                </div>
            </a>
        </div>

        <div *ngIf="finished.length == 0 && status == 3" class="uk-text-center uk-margin-large-top">
            <div class="uk-text-center uk-margin-large-top">
                <img src="../../../../assets/icons/empty.svg" width="80px" height="80px" alt="empty" />
            </div>
            <div class="uk-text-center uk-margin-large-top">
                <span class="uk-text-bold">Aucune réservation</span>
            </div>
        </div>

        <div *ngIf="canceled.length > 0" class="title bold uk-margin uk-margin-large-top">Réservations annulées</div>

        <div uk-grid class="remove-grid-ml-pl uk-margin-remove-top">
            <a uk-grid *ngFor="let reservation of canceled; let i = index" href="#"
                class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer"
                [routerLink]="['/reservation/informations', reservation.Id]">
                <div class="uk-width-1-7@s uk-width-1-3 item-column bold uk-position-relative rl-col-date">
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}" noDay="true"
                            shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular"
                            hours="{{ reservation.ISODateStart }}"></span>
                    </div>
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}" noDay="true"
                            shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular"
                            hours="{{ reservation.ISODateEnd }}"></span>
                    </div>
                    <div class="separator"></div>
                </div>
                <div class="uk-width-1-7@s uk-width-1-3 item-column light uk-text-uppercase uk-text-center rl-col-vehicle">
                    {{ reservation.Vehicle }}
                    <div class="rl-brand-model">{{ reservation.Brand }} {{ reservation.Model }}</div>
                </div>
                <div class="uk-width-1-5@s uk-width-1-3 item-column bold uk-text-uppercase rl-col-user">
                    {{ reservation.User }}
                </div>
                <div *ngIf="session.role.ability === 'super-admin'"
                    class="uk-visible@s uk-width-1-5 item-column light uk-text-uppercase rl-col-society">
                    {{ reservation.CodeSociety }}
                </div>
                <div class="uk-width-expand item-column rl-col-comment"
                    (mouseenter)="initCommentTooltip($event, reservation)">
                    <div *ngIf="testMode" class="rl-comment-debug">({{ reservation.Id }}) statut {{ reservation.Status }}, {{ getStatus(reservation.Status) }}</div>
                    <span *ngIf="reservation.Comment" class="rl-comment-text">{{ reservation.Comment }}</span>
                </div>
                <div class="uk-visible@s uk-width-1-12 item-column bold rl-col-amount"
                    *ngIf="reservation.totalAmount > 0 && reservation.demo === false">
                    {{ reservation.totalAmount.toFixed(2) }}€
                </div>
                <div class="uk-visible@s uk-width-1-12 item-column rl-col-staff" *ngIf="reservation.demo === true">
                    <span class="uk-badge" *ngIf="reservation.demo === true">Staff</span>
                    <!-- uk-display-inline-block -->
                </div>
                <div class="uk-visible@s uk-width-1-12 item-column rl-col-code"
                    [class.color-green]="reservation.Status == 14" [class.color-orange]="reservation.Status == 12">
                    #{{ reservation.Code }}
                </div>
            </a>
        </div>

        <div class="uk-margin-large" *ngIf="maxPages === 0"></div>

        <div class="uk-position-relative uk-width-1-1 uk-padding uk-margin" *ngIf="maxPages > 0">
            <div class="uk-position-center">
                <button [disabled]="currentPage === 1" class="uk-button button" (click)="prevPage()">Précédent</button>
                <div class="uk-display-inline-block" *ngFor="let item of [].constructor(maxPages); let i = index;">
                    <div *ngIf="currentPage === i + 1" class="bold uk-margin-left vop-blue">{{i + 1}}</div>
                    <div *ngIf="currentPage !== i + 1" class="uk-margin-left pointer vop-blue" (click)="goPage(i + 1)">
                        {{i + 1}}</div>
                </div>
                <button [disabled]="currentPage === maxPages" class="uk-button button uk-margin-left"
                    (click)="nextPage()">Suivant</button>
            </div>
        </div>
    </div>
</div>

<app-carsharing-update [hero]="selectCarSharing"></app-carsharing-update>

<!-- New reservation modal -->
<div id="modal-new-reservation" uk-modal="bg-close: false;" class="uk-flex-top">
    <div class="uk-modal-dialog uk-modal-body new-reservation-modal-dialog" style="width:82vw;max-width:none;margin-top:4vh;max-height:90vh;overflow-y:auto;">
        <button class="uk-modal-close-default" type="button" uk-close (click)="closeNewReservationModal()"></button>

        <h2 class="uk-modal-title color-grey bold">Nouvelle réservation</h2>

        <!-- Modal header controls: operator (super-admin only) + user search -->
        <div class="uk-grid-small uk-margin" uk-grid>

            <!-- Operator selector (super-admin only) -->
            <div *ngIf="session.role.ability === 'super-admin'" class="uk-width-1-2@m">
                <label class="label">Opérateur</label>
                <div class="uk-form-controls uk-margin-small-top">
                    <select class="input alt color-cold-grey bold uk-width-1-1"
                        (change)="onPlannerOperatorChange($event.target['value'])">
                        <option value="">-- Sélectionner un opérateur --</option>
                        <option *ngFor="let s of societies" [value]="s.Id">
                            {{ s.Name }} ({{ s.Code }})
                        </option>
                    </select>
                </div>
            </div>

            <!-- User search -->
            <div class="uk-width-1-2@m uk-position-relative"
                [class.uk-width-1-1]="session.role.ability !== 'super-admin'">
                <label class="label">Utilisateur (optionnel)</label>
                <div class="uk-form-controls uk-margin-small-top uk-flex uk-flex-middle">
                    <input class="input alt color-cold-grey bold"
                        style="flex:1;"
                        type="text"
                        [value]="plannerUserSearch"
                        (input)="onPlannerUserSearchInput($event.target['value'])"
                        placeholder="Rechercher par nom ou e-mail…">
                    <button *ngIf="plannerSelectedUser"
                        class="uk-button uk-button-link uk-margin-small-left"
                        type="button" (click)="clearPlannerUser()" title="Effacer">
                        <span uk-icon="close"></span>
                    </button>
                </div>
                <div *ngIf="plannerShowUserOptions && plannerUserOptions.length > 0"
                    class="planner-user-suggestions">
                    <div *ngFor="let u of plannerUserOptions"
                        class="planner-user-suggestion-item"
                        (mousedown)="selectPlannerUser(u)">
                        {{ u.FirstName }} {{ u.LastName }}
                        <span class="uk-text-small uk-text-muted">({{ u.EMailAddress }})</span>
                    </div>
                </div>
            </div>

        </div>

        <!-- Planner component (rendered only when modal is open) -->
        <app-reservation-planner
            *ngIf="showPlannerModal && (session.role.ability !== 'super-admin' || plannerIdSocietyVop > 0)"
            [idSocietyVop]="plannerIdSocietyVop"
            [idAccountTarget]="plannerIdAccountTarget"
            (reservationCreated)="onReservationCreated($event)"
            (cancelled)="closeNewReservationModal()">
        </app-reservation-planner>

        <!-- Super-admin placeholder before operator selection -->
        <div *ngIf="session.role.ability === 'super-admin' && plannerIdSocietyVop === 0"
            class="uk-text-center uk-margin-large uk-text-muted">
            Sélectionnez un opérateur pour afficher son planning.
        </div>

        <!-- Submission feedback -->
        <div *ngIf="newReservationError" class="uk-alert uk-alert-danger uk-margin">
            {{ newReservationError }}
        </div>
    </div>
</div>